import React from 'react'
import { Row, Col, Container } from 'react-grid-system'
import cx from 'classnames'

import Bullhorn from 'images/bullhorn.png'
import Logo from 'images/logo_sm.png'
import Paypal from 'images/paypal.png'
import RainingMoney from 'images/raining-money.png'
import ThirtySecondTimer from 'images/thirty-second-timer.png'

import layoutStyles from '../../Layout/Layout.module.scss'
import styles from '../MakeMoney.module.scss'

import Button from '../../Button'

const MakeMoneySkim = ({ currentUser }) => {
  return (
    <div className={layoutStyles.layout}>
      <Container>
        <Row>
          <Col>
            <div className={styles.pageHeader}>
              <h1 className={cx(styles.keyTwoContent, styles.center)}>Shop. Save. Share. Earn More.</h1>
            </div>

            <div className={cx(styles.makeMoneyHeader, styles.paddingContainerFirstRow)}>
              <div className={cx(styles.makeMoneyHeaderContent, styles.verticalContent)}>
                <h3 className={cx(styles.heading, styles.center)}>
                  Earn cash back on your own shopping
                </h3>

                <h3 className={cx(styles.keyTwoContent, styles.heading, styles.center)}>and</h3>

                <h3 className={cx(styles.heading, styles.center)}>
                  Bonus Cash when people you refer to Buygoon shop too!
                </h3>
                <br />

                <p className={styles.content}>
                  <span className={styles.content}>
                    Buygoon rewards you for shopping at top online retailers and for sharing the
                    platform with friends and followers who shop. Every qualifying purchase made by
                    people you refer to Buygoon adds Bonus Cash in your account.
                  </span>
                </p>

                {!currentUser && (
                  <>
                    <br />
                    <span className={styles.content}>
                      Join for <span className={styles.keyTwoContent}>free</span> and start earning
                      today.
                    </span>
                    <div className={styles.button}>
                      <Button variant="primary" href="/account/sign-up">
                        Join Now for Free
                      </Button>
                    </div>
                  </>
                )}

                {currentUser && (
                  <div className={styles.button}>
                    <Button variant="primary" href="/account/my-referral-codes">
                      Grow My Network
                    </Button>
                  </div>
                )}
              </div>

              <div className={styles.horizontalCenter}>
                <video className={styles.growMyNetworkVideo} autoPlay muted playsInline loop>
                  <source
                    src="https://s3.amazonaws.com/buygoon.com/_static-assets/videos/buygoon_animated_4_rings_white_1080p_no_audio.mp4"
                    type="video/mp4"
                  />
                  Your browser does not support the video tag.
                </video>
              </div>
            </div>
          </Col>
        </Row>
      </Container>

      <div className={cx(styles.fullWidthContainer, styles.paddingContainer)}>
        <Container>
          <Row>
            <Col>
              <div className={styles.earnMoney}>
                <div className={styles.verticalContent}>
                  <h2 className={styles.heading}>
                    Earn <span className={styles.keyTwoContent}>Bonus Cash</span> when people you
                    refer shop at top stores.
                  </h2>
                  <br />
                  <p className={styles.content}>It's simple and straight forward.</p>
                  <br />
                  <p className={styles.content}>
                    Every time your Buygoon referrals shops at one of our partner stores{' '}
                    <span className={styles.keyTwoContent}>they earn cash back</span> and{' '}
                    <span className={styles.keyTwoContent}>you earn Bonus Cash.</span>
                  </p>
                  <br />
                  <p className={styles.content}>
                    The more active shoppers in your network, the more you can earn.
                  </p>
                </div>

                <div className={styles.staticLogosContainer}>
                  <div className={styles.staticLogosRow}>
                    <img
                      className={styles.staticLogo}
                      src="https://s3.amazonaws.com/buygoon.com/_static-assets/registration_sessions-static_logo/apple-logo.png"
                    />
                    <img
                      className={styles.staticLogo}
                      src="https://s3.amazonaws.com/buygoon.com/_static-assets/registration_sessions-static_logo/target-logo.png"
                    />
                  </div>
                  <div className={styles.staticLogosRow}>
                    <img
                      className={styles.staticLogo}
                      src="https://s3.amazonaws.com/buygoon.com/_static-assets/registration_sessions-static_logo/nike-logo.png"
                    />
                    <img className={styles.staticLogo} src={Logo} />
                    <img
                      className={styles.staticLogo}
                      src="https://s3.amazonaws.com/buygoon.com/_static-assets/registration_sessions-static_logo/walmart-logo.jpg"
                    />
                  </div>
                  <div className={styles.staticLogosRow}>
                    <img
                      className={styles.staticLogo}
                      src="https://s3.amazonaws.com/buygoon.com/_static-assets/registration_sessions-static_logo/home-depot-logo.png"
                    />
                    <img
                      className={styles.staticLogo}
                      src="https://s3.amazonaws.com/buygoon.com/_static-assets/registration_sessions-static_logo/best-buy-logo.png"
                    />
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      <Container>
        <Row>
          <Col>
            <div className={cx(styles.howItWorksHeading, styles.paddingContainerHowItWorksStep)}>
              <h2 className={cx(styles.heading, styles.horizontalCenter)}>How it works</h2>
            </div>
          </Col>
        </Row>
      </Container>

      <Container>
        <Row>
          <Col>
            <div
              className={cx(
                styles.howItWorksStep,
                styles.howItWorksStepOne,
                styles.paddingContainerFirstRow
              )}
            >
              <div className={cx(styles.howItWorksStepContent, styles.verticalContent)}>
                <div className={styles.howItWorksStepTitle}>
                  {!currentUser && <h3>Sign Up</h3>}

                  {currentUser && <h3>Sign In</h3>}
                </div>

                <div className={styles.howItWorksStepDescription}>
                  <p className={styles.content}>It&apos;s quick, easy and always free to use.</p>
                </div>
              </div>

              <div className={styles.horizontalCenter}>
                <img src={ThirtySecondTimer} />
              </div>
            </div>
          </Col>
        </Row>
      </Container>

      <div className={cx(styles.fullWidthContainer, styles.paddingContainer)}>
        <Container>
          <Row>
            <Col>
              <div className={cx(styles.howItWorksStep, styles.howItWorksStepTwo)}>
                <div className={styles.horizontalCenter}>
                  <img src={Bullhorn} />
                </div>

                <div className={styles.howItWorksStepContent}>
                  <div className={styles.howItWorksStepTitle}>
                    <h3>Share Buygoon with Friends, Followers and Fellow Shoppers</h3>
                  </div>

                  <div className={styles.howItWorksStepDescription}>
                    <p className={styles.content}>
                      You already know the feeling. You find something you love online or a deal too
                      good not to share, something you just know your friends or followers would
                      want to know about. Buygoon turns that natural impulse into a reward.
                    </p>
                  </div>

                  <div className={styles.howItWorksStepDescription}>
                    <p className={styles.content}>
                      Simply share your unique Buygoon referral link alongside anything you discover
                      and love.
                    </p>
                  </div>

                  <div className={styles.howItWorksStepDescription}>
                    <p className={styles.content}>
                      When the people you refer join and shop at our partner stores, they earn
                      cash back on their purchases and you earn Bonus Cash on top. Sharing something
                      great just got a little more rewarding.
                    </p>
                  </div>

                  <div className={styles.howItWorksStepDescription}>
                    <p className={cx(styles.content, styles.keyTwoContent)}>
                      That's how Buygoon can Make Shopping More Rewarding!
                    </p>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      <Container>
        <Row>
          <Col>
            <div
              className={cx(
                styles.howItWorksStep,
                styles.howItWorksStepThree,
                styles.buygoonNetwork,
                styles.paddingContainer
              )}
            >
              <div className={cx(styles.howItWorksStepContent, styles.verticalContent)}>
                <div className={styles.howItWorksStepTitle}>
                  <h3>How Sharing Can Grow Over Time</h3>
                </div>

                <div className={styles.howItWorksStepDescription}>
                  <p className={styles.content}>
                    When people you refer to Buygoon share it with others, the reach of your
                    referrals can expand naturally.
                  </p>
                </div>
                <div className={styles.howItWorksStepDescription}>
                  <p className={styles.content}>
                    Over time, this can extend across multiple ripples of real shoppers who use
                    Buygoon to earn cash back on their purchases.
                  </p>
                </div>
                <div className={styles.howItWorksStepDescription}>
                  <p className={styles.content}>
                    When qualifying purchases are made within your extended group, you can earn
                    additional Bonus Cash related to those transactions.
                  </p>
                </div>
              </div>

              <div className={styles.horizontalCenter}>
                <video autoPlay muted playsInline loop height="350">
                  <source
                    src="https://s3.amazonaws.com/buygoon.com/_static-assets/videos/bg_animated_logo.mp4"
                    type="video/mp4"
                  />
                  Your browser does not support the video tag.
                </video>
              </div>
            </div>
          </Col>
        </Row>
      </Container>

      <div className={cx(styles.fullWidthContainer, styles.paddingContainer)}>
        <Container>
          <Row>
            <Col>
              <div className={cx(styles.howItWorksStep, styles.howItWorksStepFour)}>
                <div className={styles.horizontalCenter}>
                  <img className={styles.rainingMoneyImage} src={RainingMoney} />
                </div>
                <div className={cx(styles.howItWorksStepContent, styles.verticalContent)}>
                  <div className={styles.howItWorksStepTitle}>
                    <h3>Earn Bonus Cash When Your Referrals Shop</h3>
                  </div>

                  <div className={styles.howItWorksStepDescription}>
                    <p className={styles.content}>
                      For every qualifying purchase at a partner store made by a shopper you've
                      referred to Buygoon, they get cash back on that purchase, plus you earn Bonus
                      Cash equal to 10% of that cash back.
                    </p>
                    <br />
                    <p className={cx(styles.content, styles.keyTwoContent)}>
                      Here is how it works:
                    </p>
                    <p className={styles.content}>
                      When a shopper buys something at a partner store, that store pays Buygoon a
                      commission for delivering an active buyer.
                    </p>

                    <p className={styles.content}>
                      We use that commission to fund the shopper's cash back and your Bonus Cash.
                    </p>
                    <br />
                    <p className={cx(styles.content, styles.keyTwoContent)}>
                      You always complete your purchase directly on the retailer's website after
                      clicking through Buygoon, just like you normally would.
                    </p>

                    <br />
                    <p className={cx(styles.content, styles.keyTwoContent)}>Win-Win-Win!</p>
                    <p className={styles.content}>
                      The shopper saves money on something they wanted to buy, the retailer gains a
                      sale, and you earn Bonus Cash for building a community of shoppers who love
                      to share great finds. Everybody wins!
                    </p>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      <Container>
        <Row>
          <Col>
            <div
              className={cx(
                styles.howItWorksStep,
                styles.howItWorksStepFive,
                styles.paddingContainer
              )}
            >
              <div className={cx(styles.howItWorksStepContent, styles.verticalContent)}>
                <div className={styles.howItWorksStepTitle}>
                  <h3>Collect Your Money</h3>
                </div>

                <div className={styles.howItWorksStepDescription}>
                  <p className={styles.content}>
                    Withdraw <span className={styles.keyTwoContent}>your cash</span> from your
                    Buygoon account through PayPal.
                  </p>
                </div>
              </div>

              <div className={styles.horizontalCenter}>
                <img className={styles.paypalImage} src={Paypal} />
              </div>
            </div>
          </Col>
        </Row>
      </Container>

      <Container>
        <Row>
          <Col>
            {!currentUser && (
              <div className={styles.button}>
                <Button variant="primary" href="/account/sign-up">
                  Join Now to Make Money
                </Button>
              </div>
            )}

            {currentUser && (
              <div className={styles.button}>
                <Button variant="primary" href="/account/my-referral-codes">
                  Grow My Network
                </Button>
              </div>
            )}
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default MakeMoneySkim
